import { ContentBlockType, EchartsBlock } from '../../../model';

export const ECHARTS_NODE_NAME = 'echarts';

/**
 * Boilerplate JSON shown in the Monaco editor when the user creates a new ECharts block.
 * This is a complete, valid ECharts option that renders immediately.
 * The user replaces the sample data with their own from the ECharts examples page.
 */
export const ECHARTS_BOILERPLATE_JSON = JSON.stringify(
  {
    xAxis: {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    },
    yAxis: {
      type: 'value',
    },
    series: [
      {
        data: [150, 230, 224, 218, 135, 147, 260],
        type: 'line',
      },
    ],
  },
  null,
  2,
);

export const DEFAULT_ECHARTS_PROPS: Omit<EchartsBlock, 'id'> = {
  type: ContentBlockType.Echarts,
  options: {},
  height: 400,
};
